import React, { useEffect } from 'react';
import { Pane, Text } from 'evergreen-ui';
import { UpDownInput } from '../../Misc/UpDownInput';




export function FoldingWizard(props) {
    return (

        <Pane flex="1.5" marginLeft={64} marginRight={64} overflow="auto" height="15rem">
            <Pane display="flex" justifyContent="space-around" alignItems="center" flexDirection="row">
                <Text><strong>Folds</strong></Text>
                <Text><strong>Angle</strong></Text>
                <Text><strong>Direction</strong></Text>
            </Pane>
            {props.order.bends.map((bend, i) => {
                // console.log('Render', i, bend);
                return <Pane key={i} style={{ display: "flex", alignItems: 'baseline' }} padding={8} margin={8}
                    onMouseOver={() => { props.setIds([bend.id]) }} elevation={props.ids.indexOf(bend.id) >= 0 ? 2 : 0}>
                    <Text flex={1}> Fold {i + 1}</Text>
                    <UpDownInput
                        value={bend.value}
                        onChange={(d) => {
                            let o = props.order;
                            o.bends[i].value = d
                            props.updateBends(o.bends)
                            props.setIds([bend.id]) 
                        }} />
                 </Pane>
            })}


        </Pane>
    );
}
